import { Skeleton } from '@avanta/shared/components/ui/Skeleton';
import type * as React from 'react';

const SKELETON_ITEMS = Array.from({ length: 10 }, (_, index) => index);

export const RecentActivitySkeleton = (): React.ReactElement => (
  <div className="flex flex-col" aria-hidden>
    {SKELETON_ITEMS.map(item => (
      <div
        key={item}
        className="border-beige-200 flex gap-3 border-b py-3 first:pt-0 last:border-b-0 last:pb-0"
      >
        <Skeleton className="mt-0.5 size-4 shrink-0 rounded-sm" />
        <div className="flex min-w-0 flex-1 flex-col gap-1">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-4 w-44 max-w-full" />
          <Skeleton className="h-4 w-24" />
        </div>
      </div>
    ))}
  </div>
);
